import axios from 'axios';

const publicApi = axios.create({
    baseURL: (process.env.REACT_APP_API_URL || '/api') + '/public',
    headers: {
        'Content-Type': 'application/json',
    },
});

export default publicApi;
